import { AiOutlineMenu } from "react-icons/ai";

import "./style.css";
import { useContext } from "react";
import { DasboardContext } from "../../context/dashboard-context";
import { AuthContext } from "../../context/auth-context";

const Breadcrumb = ({ showPath }) => {
  const { sidebarOpen, setSidebarOpen } = useContext(DasboardContext);
  const { user } = useContext(AuthContext);
  const username = user?.username || "admin";

  return (
    <div className={`breadcrumb-wrapper ${sidebarOpen ? "" : "close"}`}>
      <div>
        <AiOutlineMenu onClick={() => setSidebarOpen(!sidebarOpen)} />
        <p>Viva Smart Care</p>
      </div>
      <div>
        <p>Hoşgeldiniz, {username}.</p>
      </div>
    </div>
  );
};

export default Breadcrumb;
